module.exports = __webpack_public_path__ + "static/img/portada.8ca4e348.png";